<template>
  <el-drawer :visible.sync="vis" :close-on-click-modal="false" id="vehicleDetails">
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane name="order">
        <template slot="label"><i class="el-icon-document-checked" style="margin-right:4px"></i>工单详情</template>
        <div class="formTitle">
          {{ order.schedulingNo }} /
          <el-tag size="small" :type="order.status | filterConst('SHIFTORDERSTATUS', 'type')">{{ order.status | filterConst("SHIFTORDERSTATUS") }}</el-tag>
        </div>
        <div class="box">
          <div class="item">
            <span class="title">线路名称</span>
            <span class="value">{{ order.startStationName }} - {{ order.endStationName }}</span>
          </div>
          <div class="item">
            <span class="title">班次</span>
            <span class="value">{{ order.schedulingTime | filterTime("MM-DD") }}
              {{ order.startLineTime }} - {{ order.endLineTime }}
            </span>
          </div>
          <div class="item">
            <span class="title">车票价格</span>
            <span class="value" style="color: #ff9900; font-weight: bold">￥{{ order.lineFee }}</span>
          </div>
          <br />
          <div class="item">
            <span class="title">开始时间</span>
            <span class="value">{{ order.serviceTime | filterTime }}</span>
          </div>
          <div class="item">
            <span class="title">完成/取消时间</span>
            <span class="value">{{ order.finishTime | filterTime }}</span>
          </div>

          <div class="item">
            <span class="title">实收金额</span>
            <span class="value" style="color: #ff9900; font-weight: bold">￥{{ order.realTotalFee }}</span>
          </div>
          <div class="item">
            <span class="title">车辆信息</span>
            <span v-if="order.licenseNo" :style="getPlateStyle(order.licenseNo)">{{ formatPlateNumber(order.licenseNo) }}</span>
            <span v-else class="value">-</span>
          </div>
          <div class="item">
            <span class="title">司机姓名</span>
            <span class="value">{{ order.driverName }}</span>
          </div>
          <div class="item">
            <span class="title">司机电话</span>
            <span class="value">{{ order.driverPhone }}</span>
          </div>
        </div>

        <div class="formTitle">乘客订单</div>

        <el-table style="margin-bottom: 20px" border empty-text="暂无数据" :data="orderVoList" highlight-current-row>
          <el-table-column v-for="(item, index) in columns" :key="index" show-overflow-tooltip :prop="item.prop" :label="item.label" :width="item.width">
            <template slot-scope="{ row }">
              <template v-if="item.prop === 'created'">{{
                row.created | filterTime
              }}</template>
              <template v-else-if="item.prop === 'customerName'">
                {{ row.customerName }} {{ row.customerPhone }} {{ row.passengerNum }}人
              </template>
              <template v-else-if="item.prop === 'status'">
                <span v-if="row.status !== 45">{{
                  row.status | filterOrderSubStatus
                }}</span>
                <span v-if="row.status === 45">
                  {{
                    row.loadType === 2
                      ? "未上车"
                      : row.status | filterOrderSubStatus
                  }}</span>
              </template>
              <template v-else-if="item.prop === 'orderNo'">
                <span>{{ row.orderNo }}</span>
                <el-tag v-if="row.isTicketChanging === 1" style="margin-left: 8px">改签</el-tag>
              </template>
              <template v-else-if="item.prop === 'realFee'">
                <template v-if="row.realFee || row.realFee === 0">
                  <span class="util-money">￥{{ row.realFee }}</span>
                  <span v-if="row.couponFee">(优惠券<span class="util-money-minus">-￥{{ row.couponFee }}</span>)</span>
                </template>
                <span v-if="!row.realFee && row.realFee !== 0">-</span>
              </template>
              <template v-else>{{
                row[item.prop] ? row[item.prop] : "-"
              }}</template>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="{ row }">
              <span class="link" @click="lookLocation(row)">查看上下车位置</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane name="map">
        <template slot="label"><i class="el-icon-map-location" style="margin-right:4px"></i>地图查看</template>
        <el-button v-show="showDriver" @click="getDriverLocation" plain style="position: absolute; left: 34%; top: 2%; z-index: 999">查看司机实时位置</el-button>
        <el-table style="width: 30%; display: inline-block; vertical-align: top" border empty-text="暂无数据" :data="orderVoList" @row-click="rowClick" ref="mapTable" highlight-current-row>
          <el-table-column v-for="(item, index) in columnsMap" :key="index" show-overflow-tooltip :prop="item.prop" :label="item.label" :width="item.width">
            <template slot-scope="{ row }">
              <template v-if="item.prop === 'customerName'">{{
                row.customerName +
                " " +
                row.customerPhone +
                " " +
                row.passengerNum +
                "人"
              }}</template>
              <template v-else-if="item.prop === 'status'">
                <span v-if="row.status !== 45">{{
                  row.status | filterOrderSubStatus
                }}</span>
                <span v-if="row.status === 45">
                  {{
                    row.loadType === 2
                      ? "未上车"
                      : row.status | filterOrderSubStatus
                  }}</span>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div id="order-map" style="display: inline-block"></div>
      </el-tab-pane>
    </el-tabs>
  </el-drawer>
</template>

<script>
import AMap from "AMap";
export default {
  name: "vehicleDetails",
  props: {
    visible: {
      // 显隐
      default() {
        return false;
      },
    },
    order: {
      // 订单
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      id: this.$route.query.id,
      tabAction: "order",
      map: null,
      vis: false,
      columns: [
        { prop: "orderNo", label: "订单号", width: 200 },
        { prop: "status", label: "订单状态", width: 90 },
        { prop: "created", label: "下单时间" },
        { prop: "customerName", label: "乘客信息", width: 220 },
        { prop: "seatNo", label: "座位", width: 80 },
        { prop: "realFee", label: "实付金额", width: 100 },
        { prop: "remark", label: "备注", width: 180 },
      ],
      columnsMap: [
        { prop: "status", label: "订单状态" },
        { prop: "customerName", label: "乘客信息", width: 220 },
      ],
      orderVoList: [],
      markerDriver: null,
      markerBegin: null,
      markerEnd: null,
      showDriver: false,
      driverLocation: null,
      checkRow: false,
    };
  },
  watch: {
    visible(val) {
      this.vis = val;
    },
    vis(val) {
      if (!val) {
        if (this.markerBegin) {
          this.markerBegin.setMap(null);
          this.markerEnd.setMap(null);
        }
        if (this.markerDriver) {
          this.markerDriver.setMap(null);
        }
        this.checkRow = false;
      } else if (this.tabAction == "map") {
        this.$nextTick(() => {
          this.rowClick(this.orderVoList[0]);
        });
      }
      this.$emit("update:visible", val);
    },
    order: {
      handler(val) {
        if (val) {
          this.orderVoList = val.orderVoList;
          if (val.status == 40) {
            this.showDriver = true;
          } else {
            this.showDriver = false;
          }
        }
      },
      deep: true,
    },
    tabAction(val) {
      if (val == "map") {
        if (!this.map) {
          this.initMap();
        }
        if (this.showDriver) {
          this.getDriverLocation();
        }
        if (!this.checkRow) {
          this.rowClick(this.orderVoList[0]);
        }
      }
    },
  },
  methods: {
    // 地图初始化
    initMap() {
      this.map = new AMap.Map("order-map", {
        mapStyle: 'amap://styles/572516903e2f1273ed9c97f54ebacd89',
        resizeEnable: true,
        zoom: 11,
        center: new AMap.LngLat(104.065861, 30.657401),
      });
    },
    // 查看上下车位置
    lookLocation(row) {
      this.tabAction = "map";
      this.$nextTick(() => {
        this.rowClick(row);
      });
    },
    // 点击行加载标点
    async rowClick(row) {
      this.checkRow = true;
      this.$refs.mapTable.setCurrentRow(row);
      if (this.markerBegin) {
        this.markerBegin.setMap(null);
        this.markerEnd.setMap(null);
      }

      let begin = row.address[0];
      let end = row.address[1];
      let beginContent = `<div  style="
                                padding: 10px;
                                justify-content: center;
                                align-items: center;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #FFFFFF;
                                box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.30);
                                background-color: #4dace2;">
                                <div style="text-align:center;margin-bottom:5px;">${row.customerPhone}</div>
                                <div>上车地点：${begin.name}</div>
                            </div>`;
      let endContent = `<div  style="
                                padding: 10px;
                                justify-content: center; 
                                align-items: center;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #FFFFFF;
                                box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.30);
                                background-color: #47c147;">
                                <div style="text-align:center;margin-bottom:5px;">${row.customerPhone}</div>
                                <div>下车地点：${end.name}</div>
                          </div>`;

      this.markerBegin = new AMap.Marker({
        position: new AMap.LngLat(begin.longitude, begin.latitude),
        icon: require("@/assets/img/markerBegin.png"),
        map: this.map,
      });
      this.markerBegin.setLabel({
        offset: new AMap.Pixel(0, -6),
        content: beginContent,
        direction: "top",
      });

      this.markerEnd = new AMap.Marker({
        position: new AMap.LngLat(end.longitude, end.latitude),
        icon: require("@/assets/img/markerEnd.png"),
        map: this.map,
      });
      this.markerEnd.setLabel({
        offset: new AMap.Pixel(0, -6),
        content: endContent,
        direction: "top",
      });

      this.$nextTick(() => {
        this.map.setFitView();
      });
    },
    // 查看司机位置
    async getDriverLocation() {
      if (this.markerDriver) {
        this.markerDriver.setMap(null);
      }
      let url = "/api/V1/manage/order/scheduling/driver/location";
      let params = {
        driverId: this.order.driverId,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        if (data.data) {
          this.markerDriver = new AMap.Marker({
            position: new AMap.LngLat(
              data.data.location.longitude,
              data.data.location.latitude
            ),
            icon: require("@/assets/img/car.png"),
            map: this.map,
          });
          this.map.setCenter([
            data.data.location.longitude,
            data.data.location.latitude,
          ]);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
#vehicleDetails {
  /deep/.el-drawer {
    overflow: hidden;
    width: 70% !important;
  }
  .link {
    text-decoration: none;
  }
  #order-map {
    display: inline-block;
    vertical-align: top;
    width: 68%;
    margin-left: 2%;
    height: 830px;
  }
  .el-col {
    margin: 15px 0;
  }
  .box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    font-size: 14px;
    .item {
      width: 33%;
      margin: 15px 0;
      .title {
        display: inline-block;
        width: 100px;
        margin-right: 20px;
      }
      .value {
        color: #999;
        &:empty {
          &::after {
            content: "-";
          }
        }
      }
    }
  }
}
</style>
